// Mock data for Website Symphony

export const navLinks = [
  { name: 'Home', href: '#home', hasDropdown: false },
  { name: 'Web Design', href: '#web-design', hasDropdown: true, items: ['Website Design', 'eCommerce', 'Website Redesign', 'Web Platforms', 'Web Development'] },
  { name: 'A.I.', href: '#ai', hasDropdown: true, items: ['AI Integration', 'AI Automation', 'AI Chatbots', 'AI Marketing'] },
  { name: 'Marketing', href: '#marketing', hasDropdown: true, items: ['SEO Services', 'Content Writing', 'Social Media', 'Video Advertising'] },
  { name: 'Hosting', href: '#hosting', hasDropdown: true, items: ['Web Hosting', 'Domain Names', 'SSL Certificates', 'Email Hosting'] },
  { name: 'Portfolio', href: '#portfolio', hasDropdown: false },
];

export const packages = [
  {
    id: 1,
    title: 'Redevelopment Design Packages',
    image: 'https://images.unsplash.com/photo-1527443195645-1133f7f28990?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx3ZWJzaXRlJTIwbW9ja3VwfGVufDB8fHx8MTc4MDkwNzc0NHww&ixlib=rb-4.1.0&q=85',
    description: 'Redesigning and updating your website will improve the presentation of your business as well as generate a more user-friendly experience.',
    features: [
      'Latest Website Technology',
      'Popular Website CMS Platform',
      'Redesign UI & UX Design',
      'All Stock Photos Provided',
      'Modern Website Platforms',
      'Web Platform Update & Upgrade',
      'Responsive Website UI',
      '2 - 3 Week Delivery',
      'Including Edits, Changes & Revisions',
      'Complete Setup and Deployment',
    ],
  },
  {
    id: 2,
    title: 'eCommerce Website Packages',
    image: 'https://images.unsplash.com/photo-1707836885254-79b6e3d7b18d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHx3ZWJzaXRlJTIwbW9ja3VwfGVufDB8fHx8MTc4MDkwNzc0NHww&ixlib=rb-4.1.0&q=85',
    description: 'eCommerce websites generate revenue online — all eCommerce websites are built using top-of-the-industry security and payment gateways.',
    features: [
      'Business Website w/ eCommerce',
      'Product Titles, Descriptions & Prices',
      'Product & Inventory Pictures',
      'Payment Gateways',
      'Billing Setup & Integration',
      'Authorize.net',
      'PayPal Payment Processing',
      'Product & Inventory Photos',
      '5 - 6 Week Turn-Around',
      'Complete Setup and Deployment',
    ],
  },
  {
    id: 3,
    title: 'Enterprise Website Packages',
    image: 'https://images.unsplash.com/photo-1627542557169-5ed71c66ed85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHx3ZWJzaXRlJTIwbW9ja3VwfGVufDB8fHx8MTc4MDkwNzc0NHww&ixlib=rb-4.1.0&q=85',
    description: 'When building a new website, consider the CMS (Content Management System) that is going to best suit your business\u2019s online needs.',
    features: [
      'Payment Gateways & eCommerce',
      'On-Page SEO (Search Optimization)',
      'Corporate/Enterprise Websites',
      'Magento, Drupal, Joomla & More',
      'Customized UI & UX',
      'Popular Web Platforms',
      'Stock Photos',
      'Large & Small Businesses',
      'Testing & Troubleshooting',
      'Complete Setup and Deployment',
    ],
  },
  {
    id: 4,
    title: 'Website Design & Development Package',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHx3ZWIlMjBkZXNpZ24lMjB0ZWFtfGVufDB8fHx8MTc4MDkwNzc0NHww&ixlib=rb-4.1.0&q=85',
    description: 'Utilize our expert website design and development team to give your business the edge to get ahead of your online competition.',
    features: [
      'Informational Business Website',
      'WordPress CMS Platform',
      'Shopify CMS Platform',
      'Customized UI & UX Design',
      'Stock Photos Provided',
      'Mobile Responsive',
      '2 - 3 Week Delivery',
      'Edits, Changes & Revisions',
      'Complete Setup and Deployment',
    ],
  },
];

export const projects = [
  { name: 'Outinord Symphony', image: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzgwOTA3NzQ0fDA&ixlib=rb-4.1.0&q=85', description: 'A vibrant corporate website showcasing premium services with smart automation and modern design.' },
  { name: 'UCardiology Fellows', image: 'https://images.unsplash.com/photo-1497215842964-222b430dc094?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzgwOTA3NzQ0fDA&ixlib=rb-4.1.0&q=85', description: 'A medical fellowship platform built for ease, accessibility and student onboarding.' },
];

export const portfolioProjects = [
  { name: 'CRA-MN.com', tag: 'Roadracing Association', image: 'https://images.unsplash.com/photo-1558981403-c5f9899a28bc?w=600&q=80', description: 'The Midwest\u2019s home for safe, organized motorcycle road racing built by racers, volunteers, and officials since 1970.' },
  { name: 'TrussCorp.com', tag: 'Custom Truss Manufacturing', image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&q=80', description: 'Trusted Custom Truss Manufacturing since the 1970s. Family-owned manufacturer in Miami specializing in prefabricated trusses.' },
  { name: 'TheHauteCorner.com', tag: 'Fashion eCommerce', image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600&q=80', description: 'Where timeless fashion meets modern luxury. A new Shopify eCommerce website design and development launch.' },
  { name: 'Booking4Fun.com', tag: 'Tour Booking', image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&q=80', description: 'Your personal deal-hunting butler, snagging the highest-rated Key West adventures without hidden fees.' },
  { name: 'FloridaSpringsCabins.com', tag: 'Cabin Rentals', image: 'https://images.unsplash.com/photo-1449158743715-0a90ebb6d2d8?w=600&q=80', description: 'The ultimate online destination for planning unforgettable stays at the most beautiful springs in Florida.' },
  { name: 'TheHomeTiles.com', tag: 'Flooring & Paving', image: 'https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=600&q=80', description: 'A leading specialty retailer of hard surface flooring offering the broadest in-stock selection of tiles, wood and stone.' },
  { name: 'ExpressionsGalerie.com', tag: 'Fine Art Gallery', image: 'https://images.unsplash.com/photo-1577083552431-6e5fd01988ec?w=600&q=80', description: 'A premier destination for contemporary Haitian art in Pétion-Ville, Haiti, established 1991.' },
  { name: 'Viejolazaro.com', tag: 'Spiritual Products', image: 'https://images.unsplash.com/photo-1604881991720-f91add269bed?w=600&q=80', description: 'Both an online and physical Botanica for Santeria supplies, education and community.' },
  { name: 'CountyWidePI.com', tag: 'Private Investigation', image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80', description: 'Trusted Private Investigation Services with over two decades of experience for legal, corporate and governmental sectors.' },
];

export const aiBullets = [
  'Custom A.I. solutions (no cookie-cutter setups)',
  'Seamless integration with your current website',
  'Scalable systems designed for growth',
  'Ongoing support and optimization',
];

export const stats = [
  { value: '20+', label: 'Years in Business' },
  { value: '750+', label: 'Websites Launched' },
  { value: '98%', label: 'Client Satisfaction' },
  { value: '24/7', label: 'Support Available' },
];
